<template>
  <q-dialog
    :ref="modalRef"
    v-cloak
    :full-width="windowWidth <= 1025"
    :position="windowWidth <= 1025 ? 'bottom' : 'standard'"
  >
    <q-card class="bg-background-light" style="width: 100%; max-width: 424px">
      <DialogHeader header="Your Search Location" header-icon="sym_r_place" />

      <q-form @submit="submitPostalCodeInputForm()">
        <q-card-section class="row q-col-gutter-sm q-py-lg">
          <q-input
            standout
            v-model="postalCode"
            label="Zip Code"
            class="col-12"
            :error="postalCodeError != null"
            :error-message="postalCodeError"
            inputmode="numeric"
            pattern="[0-9]*"
            mask="#####"
          />
          <q-select
            standout
            class="col-12"
            v-model="radius"
            :options="this.$store.state.search.filter.options.locationRadius"
            label="Search Within"
            emit-value
            map-options
          />
        </q-card-section>
        <q-card-section class="q-pt-none">
          <q-btn
            rounded
            label="Update"
            type="submit"
            color="secondary"
            class="full-width"
            :disable="disableSubmit"
            :loading="disableSubmit"
            no-caps
          />
        </q-card-section>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import DialogHeader from "@/components/UI/DialogHeader.vue";

export default {
  name: "PostalCodeInputDialog",
  components: { DialogHeader },
  data() {
    return {
      modalRef: "autoSearchPostalCodeInputModal",
      disableSubmit: false,
      postalCode: this.$store.state.search.location.postalCode,
      postalCodeError: null,
      radius: this.$store.state.search.location.radius
    };
  },
  computed: {},
  mounted() {},
  methods: {
    show() {
      this.$refs[this.modalRef].show();
    },
    hide() {
      this.$refs[this.modalRef].hide();
    },
    submitPostalCodeInputForm() {
      this.disableSubmit = true;

      this.$store
        .dispatch("geolocation/VALIDATE_POSTAL_CODE", this.postalCode)
        .then(locationData => {
          this.postalCodeError = null;

          this.$store.commit("search/SET_LOCATION", {
            postalCode: this.postalCode,
            city: locationData["city"],
            state: locationData["state"],
            radius: this.radius
          });

          this.$store.commit("search/RESET_PAGINATION");
          this.$store.commit("search/SET_LOADING");
          this.hide();
        })
        .catch(error => {
          this.postalCodeError = error;
        })
        .finally(() => {
          this.disableSubmit = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
